/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import * as Utilities from '../../utilities.js';
import { FormInputGroup } from '../../../react/form_input_group';
import { FormHeader } from '../../../react/form_header';

// How often to update the screen reader countdown
const SCREEN_READER_COUNTDOWN_INTERVAL = 60000; // 60 seconds
const SCREEN_READER_COUNTDOWN_INTERVAL_PRIORITY = 10000; // 10 seconds

// Remaining time to increase frequency of screen reader countdown updates
const SCREEN_READER_COUNTDOWN_PRIORITY = 30000; // 30 seconds remaining

const formatRemainingTimeForScreenReader = function(remaining_time) {
  const interval = remaining_time <= SCREEN_READER_COUNTDOWN_PRIORITY ?
    SCREEN_READER_COUNTDOWN_INTERVAL_PRIORITY
  :
    SCREEN_READER_COUNTDOWN_INTERVAL;

  // Subtract one second to ensure the screen reader update happens when the visible timer shows the same remaining time
  const throttled_remaining_time = Math.ceil((remaining_time - 1000) / interval) * interval;

  const duration = moment.duration(throttled_remaining_time);
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  const formatted_remaining = [];
  if (minutes > 0) { formatted_remaining.push(`${minutes} minute${minutes === 1 ? '' : 's'}`); }
  if (seconds > 0) { formatted_remaining.push(`${seconds} second${seconds === 1 ? '' : 's'}`); }

  // Avoid an empty "Complete your registration in" message at the end of the timer
  if ((minutes > 0) || (seconds > 0)) {
    return `Complete your registration in ${formatted_remaining.join(' ')}`;
  } 
    return "";
  
};

export var ReservationTimer = (function() {
  ReservationTimer = class ReservationTimer extends React.Component {
    static initClass() {
      this.propTypes = {
        // How often to update the countdown
        frequency: PropTypes.number,
        // Current server time
        now: PropTypes.any.isRequired,
        // Reservation end time, again as server time
        reservationEnds: PropTypes.any.isRequired,
        // Offset for browser's time from the server, will be computed from now if not provided
        browserTimeOffset: PropTypes.number
      };
  
      this.defaultProps =
        {frequency: 1000};
    }

    constructor(props) {
      super(props);
this._countdownTimerFired = this._countdownTimerFired.bind(this);

      const now = moment(props.now);
      const reservation_ends_at = moment(props.reservationEnds);
      const time_difference = reservation_ends_at.diff(now);
      const browser_time_offset = props.browserTimeOffset || moment().diff(props.now);

      const current = moment().subtract(browser_time_offset, 'ms');
      const remaining = reservation_ends_at.diff(current);

      // Initialize state with the provided props for answers
      this.state = {
        // Server's current timestamp, used for calculating the offset
        now,
        // Offset between browser time and server time
        browser_time_offset: this.props.browserTimeOffset || browser_time_offset,
        // Server time reservation ends
        reservation_ends_at,
        // Remaining time, in milliseconds, of the reservation
        remaining_time: remaining
      };

      // Set up callback for time countdown
      if (!this._countdownTimer) { this._countdownTimer = setInterval(this._countdownTimerFired, this.props.frequency); }
    }

    componentWillUnmount() {
      // Cancel the timer for the countdown clock
      clearInterval(this._countdownTimer);
      return this._countdownTimer = null;
    }

    // Callback to update the countdown timer every 0.9 seconds
    _countdownTimerFired() {
      const current = moment().subtract(this.state.browser_time_offset, 'ms');
      const remaining = this.state.reservation_ends_at.diff(current);

      this.setState({remaining_time: remaining});

      if (remaining <= 0) {
        clearInterval(this._countdownTimer);
        return this._countdownTimer = null;
      }
    }


    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.reservationEnds === nextProps.reservationEnds) { return; }

      // Update Remaining time state
      const now = moment(nextProps.now);
      const reservation_ends_at = moment(nextProps.reservationEnds);
      const time_difference = reservation_ends_at.diff(now);
      const browser_time_offset = moment().diff(nextProps.now);

      const current = moment().subtract(this.state.browser_time_offset, 'ms');
      const remaining = reservation_ends_at.diff(current);

      // Update state with the provided props for answers
      this.setState({
        // now: now
        reservation_ends_at,
        // browser_time_offset: browser_time_offset
        remaining_time: remaining
      });
      // Set timer for time updates
      if (!this._countdownTimer) { return this._countdownTimer = setInterval(this._countdownTimerFired, this.props.frequency); }
    }


    render() {
      let remaining_message; let remaining_message_for_screen_reader; let remaining_time;
      if (this.state.remaining_time <= 0) {
        remaining_message = "Ticket hold expired";
        remaining_message_for_screen_reader = "Ticket hold expired";
      } else {
        remaining_time = moment.duration(this.state.remaining_time);
        remaining_message = `Complete your registration in ${Utilities.formatDuration(remaining_time)}`;
        remaining_message_for_screen_reader = formatRemainingTimeForScreenReader(this.state.remaining_time);
      }

      return <FormInputGroup className="reservation_timer">
        <div role="timer" aria-atomic="true">
          {remaining_message}
        </div>
        <span className="sr-only" aria-atomic="true" aria-live={this.state.remaining_time <= 0 ? 'assertive' : 'polite'}>
          {remaining_message_for_screen_reader}
        </span>
      </FormInputGroup>;
    }
  };
  ReservationTimer.initClass();
  return ReservationTimer;
}());
